import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Spin } from "antd"; // Ant Design loader
import Swal from "sweetalert2";
import { post } from "../API/api_helper";

interface SendIdModalProps {
  show: boolean;
  handleClose: () => void;
  grade?: string;
  division?: string;
}

const SendIdModal: React.FC<SendIdModalProps> = ({ show, handleClose }) => {
  const [senderEmail, setSenderEmail] = useState<string>("");
  const [grade, setGrade] = useState<string>("");
  const [division, setDivision] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!senderEmail) {
      Swal.fire("Sender email is required");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        sender_email: senderEmail,
        grade: grade || null,
        division: division || null,
      };

      const res = await post("/idcards/generate", payload);

      console.log(payload);
      
      if (res.success) {
        Swal.fire("Mail send Successfull");
        window.open(res.link, "_blank");
        handleClose();
      } else {
        Swal.fire("Failed to generate link");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Send ID Cards</Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Spin spinning={loading} tip="Sending..." style={{ width: "100%" }}>
            <Form.Group className="mb-3" controlId="senderEmail">
              <Form.Label>Sender Email</Form.Label>
              <Form.Control
                type="email"
                value={senderEmail}
                onChange={(e) => setSenderEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="grade">
              <Form.Label>Grade (optional)</Form.Label>
              <Form.Control
                type="text"
                value={grade}
                onChange={(e) => setGrade(e.target.value)}
                placeholder="e.g. 11"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="division">
              <Form.Label>Division (optional)</Form.Label>
              <Form.Control
                type="text"
                value={division}
                onChange={(e) => setDivision(e.target.value)}
                placeholder="e.g. A"
              />
            </Form.Group>
          </Spin>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Close
          </Button>
          <Button type="submit" variant="primary" disabled={loading}>
            Send ID Cards
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SendIdModal;
